import { each } from "jquery";
import * as intlTelInput from 'intl-tel-input';
import * as intlTelInputUtils from 'intl-tel-input/build/js/utils.js';
import { noWorkingDaysSummary } from './summary.js';

class FormMapsSummary {
    constructor() {
        this.branches = [];
        //PHONE NUMBER
        this.itiMapsSummary = null;
        this.currentCountry = 'es'; //default
        this.onlyCountries = [this.currentCountry];
        this.map = null;
        this.userLocation = null;
        this.infowindow = null;
        this.bindSummaryBranches();
    }

    async getBranches(location) {
        var that = this;
        $('#summary-branch-map').hide();
        //$('.summary-branch-content').hide();
        $('.summary-title #error-advisor').hide();
        $.ajax({
            url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"form/branchList",
            data: "pavh="+$('#dealer').val(),
            type:'POST',
            beforeSend: function() {
                if($('#summary-branch-map').length>0) {
                    $('.summary-map-loader .wrap-loader').show();
                }
            },
            success: function(result) {
                if(result!='-1') {
                    var IS_JSON = true;
                    try{
                        var obj = JSON.parse(result);
                    }catch(err){
                        IS_JSON = false;
                    } 
                    if(IS_JSON){
                        var wsId = $('#ws-id').val();
                        if($('#summary-branch-map').length>0) {
                            obj.forEach(element => {
                                if(element.latitude!='' && element.longitude) {
                                    that.branches.push(element);
                                }
                            });
                            var element = that.branches.find(o => o.id === wsId);
                            that.paintSelectedBranch(element);
                        } else {
                            //$('.summary-branch-content').show();
                            $('.summary-title #error-advisor').show();
                            that.branches = obj;
                        }
                    }
                }
            }
        })
    }

    async paintSelectedBranch(element) {
        var latlng = new google.maps.LatLng(element.latitude, element.longitude);
        var mapOptions = {
			center: latlng,
			zoom: 17,
            mapTypeId: 'roadmap'
        }
        $('#summary-branch-map').show();
        $('#wf-map-branch-info-summary').html('');
        this.map = new google.maps.Map(document.getElementById('wf-map-branches-summary'), mapOptions);

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(element.latitude, element.longitude),
            map: this.map,
            title: element.name.toUpperCase()
        });
        google.maps.event.addListener(marker, 'click', (function(marker) {
            return function() {
                infowindow.setContent(element.name.toUpperCase());
                infowindow.open(that.map, marker);
                that.map.setZoom(19);
                that.map.setCenter(marker.getPosition());
                that.selectBranchFromMap(element);
            }
        })(marker));
        $('.summary-map-loader .wrap-loader').hide();
        $('#summary-branch-map').show();
        //$('.summary-branch-content').show();
        //$('.summary-title #error-advisor').show();

        this.selectBranchFromMapSummary(element);
    }

    phoneInputSummary(element) {
        var that = this;
        this.currentCountry = $('#country-code').val();
        this.onlyCountries = [this.currentCountry];
        this.itiMapsSummary = intlTelInput(document.querySelector(element), {
            initialCountry: that.currentCountry,
            nationalMode: true,
            autoPlaceholder: "off",
            utilsScript: "../../build/js/utils.js"
        });
    }

    selectBranchFromMapSummary(element) {
        var code = " "; 
        if(element.code) {
            code = (element.code!='' ? (element.code+" - ") : " ");
        }
        var block = '<div class="w-100 wf-branch-list wf-list-block wf-list-block-'+element.id+'" id="wf-list-block-'+element.id+'" data-id="'+element.id+'" data-slot="'+element.slot_duration+'">';
        block += '<div class="w-100" wf-id="' + element.id + '">';
        block += '<div class="wf-list-row wf-list-fc w-100 row"><div class="wf-list-name col-12">' + element.name + '</div></div>';
        block += '<div class="w-100 row wf-list-subtitle"><div class="col-12 wf-list-row wf-list-sc">' + element.address + '</div></div>';
        block += '<input type="hidden" id="ws-id" name="ws-id" value="'+element.id+'"/>';
        block += '</div>';
        block += '<div class="row w-100 wf-list-extra">';
        block += '<div class="col-12">';
        block += '<div class="w-100">'+ code + element.city+ ', ' + element.state +'</div>';
        block += '<div class="w-100 mobile-field-disabled">';
        block += '<input type="text" id="mobile-field-'+element.id+'" disabled class="form-control mobile-field" value="'+element.telephone+'"/>';
        block += '</div>';
        block += '</div></div>';
        $('#wf-map-branch-info-summary').append(block);

        // $('.summary-branch-content').scrollTop(0);
        // $('.summary-branch-content').animate({
        //     scrollTop: $('.summary-branch-content #wf-list-block-'+element.id).offset().top - $('.summary-branch-content').offset().top
        // }, 500);

        this.phoneInputSummary('#'+$('#wf-map-branch-info-summary .mobile-field').attr('id'));
    }

    bindSummaryBranches() {
        var that = this;
        $('.summary-branch-content .wf-list-block').on('click', function() {
            $('#error-advisor').hide();
            $('#error-advisor').find('.error').removeClass('d-block');
            $('#error-advisor').find('.error-msg').html("");
            if($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            } else {
                var element = $(this);
                $('.wf-branch-list').each(function() {
                    $(this).find('.wf-list').removeClass('selected');
                    var id = $(this).attr('id');
                    if($(this) !== $(element)) {
                        $('.summary-branch-content #'+id).find('.collapse').removeClass('show');
                    }
                });
                $(this).find('.wf-list').addClass('selected');
                $('#ws-id').val($(this).attr('data-id'));
                var wsId = $(this).attr('data-id');
                var element = that.branches.find(o => o.id === wsId);
                $('.sumary-branch .branch-list-content').animate({
                    scrollTop: 0
                }, 1000);
                if($('#summary-branch-map').length>0) {
                    that.selectBranchFromMapSummary(element);
                    that.paintSelectedBranch(element)
                }
            }
            $('#appointment-summary-continue').prop('disabled',true); 
            if($('#appointment_advisor_summary').length>0) {
                if(!$('.scheduleBlock').is(":visible")){
                    $(".scheduleBlock").slideUp('slow', function() {});
                }
            } else {
                $(".scheduleBlock").slideDown('slow', function() {});
                $('.summary-block #btn-change-date').prop('disabled', false);
            }
            if($('.summary-block #error-advisor').is(':visible')) {
                $('.summary-block #btn-change-date').prop('disabled', true);
            }
            noWorkingDaysSummary(false);
        });
    }
    
}
export { FormMapsSummary }